export const MuiDataGrid = {
  styleOverrides: {
    root: {
      '& .MuiDataGrid-columnSeparator .MuiDataGrid-iconSeparator': {
        display: 'none',
      },
      '& .MuiDataGrid-columnHeaderTitleContainer': {
        padding: 'none',
      },
      '& .MuiDataGrid-columnHeader': {
        height: '52px',
      },
      '& .MuiDataGrid-iconButtonContainer': {
        marginBottom: '5px',
      },
    },
  },
};
